<template>
  <div class="dialog-container" v-loading="isUpdating">
    <el-row :gutter="18">
      <el-col :span="24">
        <el-form ref="userDetails" :model="form" :rules="rules" label-width="30%">
          <el-form-item label="Name" prop="fullName">
            <el-input v-model="form.fullName" placeholder="Name"></el-input>
          </el-form-item>
          <el-form-item label="Department" prop="departmentId">
            <el-select v-model="form.departmentId" placeholder="Select Department">
              <el-option
                v-for="department in filteredDepartments"
                :key="department.id"
                :label="department.name"
                :value="department.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="Email Address">
            <el-input v-model="form.email" placeholder="Email Address"></el-input>
          </el-form-item>
          <el-form-item label="Phone">
            <el-input v-model="form.phone" placeholder="Phone"></el-input>
          </el-form-item>
          <el-form-item label="Active?">
            <el-switch v-model="form.active"></el-switch>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>
    <el-row :gutter="18" class="dialog-footer">
      <el-col :span="24" class="align-right">
        <el-button @click="closeDialog">Cancel</el-button>
        <el-button type="primary" @click="updateUser">Update User</el-button>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import get from 'lodash/get';
import extend from 'lodash/extend';
import trim from 'lodash/trim';
import filter from 'lodash/filter';
import { Required, GenericDoubleBlindValidation } from '@/util/formValidators';
import User from '@/model/User';
import api from '@/api';

export default {
  props: {
    user: {
      type: Object,
      default() {
        return new User();
      },
    },
  },
  data() {
    return {
      isUpdating: false,
      form: {
        id: null,
        fullName: null,
        departmentId: null,
        email: null,
        phone: null,
        active: null,
      },
      rules: {
        fullName: [Required],
        departmentId: [{ trigger: 'change', ...Required }],
      },
    };
  },
  methods: {
    ...mapActions('Lookup', ['getDepartments']),
    updateUser() {
      this.$refs.userDetails.validate((valid) => {
        if (valid) {
          // trim all values
          Object.keys(this.form).forEach((key) => {
            if (typeof this.form[key] === 'string') {
              this.form[key] = trim(this.form[key]);
            }
          });

          const user = extend({}, User, this.form);
          this.isUpdating = true;
          api.user.update(user).then((response) => {
            this.$notify.success({
              title: 'Success',
              message: 'User successfully updated.',
              position: 'bottom-right',
            });
            this.$emit('userUpdated', response.data);
            this.closeDialog();
          }).catch(e => console.error(e))
            .finally(() => {
              this.isUpdating = false;
            });
          return true;
        }
        return false;
      });
    },
    closeDialog() {
      this.$emit('close');
    },
    mustMatch(formItem) {
      return (...args) => {
        GenericDoubleBlindValidation(get(this, formItem), ...args);
      };
    },
    copyUserToForm() {
      Object.keys(this.form).forEach((key) => {
        this.form[key] = this.user[key];
      });
    },
  },
  computed: {
    ...mapGetters('Lookup', ['allDepartments']),
    ...mapGetters('User', {
      loggedInUser: 'user',
    }),
    filteredDepartments() {
      return filter(this.allDepartments, department => department.id <= this.loggedInUser.departmentId);
    },
  },
  watch: {
    user() {
      this.copyUserToForm();
    },
  },
  mounted() {
    this.getDepartments();
    this.copyUserToForm();
  },
};

</script>
